import $ from 'jquery';

function burger() {
	function parseAtribute(str) {
		if (typeof str === 'undefined') {
			return null;
		}

		if (str) {
			var arrayItems = str.split(',');
			var clearArrayItems = arrayItems.map(function (classString) {
				return classString.trim();
			});

			return clearArrayItems;
		}
	}

	var $navTrigger = $('.js-burger-trigger');

	$navTrigger.on('click', function () {
		var toggleTarget = $(this).data('toggleTarget');
		var toggleClass = $(this).data('toggleClass');

		if (toggleTarget && toggleClass) {
			var targetList = parseAtribute(toggleTarget);
			var classList = parseAtribute(toggleClass);

			if (targetList.length && classList.length) {
				targetList.forEach(function (item, i) {
					if (typeof classList[i] !== 'undefined') {
						$(item).not(this).toggleClass(classList[i]);
					}
				});
			}
		}

		return false;
	});
}

export default burger;



// WEBPACK FOOTER //
// ./app/blocks/burger/burger.js